import React, { useEffect } from "react";
import toast from "react-hot-toast";
import { Card, Title, Text, BarChart } from "@tremor/react";
import * as Common from "../../../Components/Common";
import { getTaskSummaryData } from "../../../Services/DashboardService";
import { TOAST_MESSAGES } from "../../../Constants/Strings";
import { useDashboard } from "../../../Context";
import { extractErrorMessage } from "../../../Utils/extractErrorMessage";

const TaskSummary = () => {
  const [taskData, setTaskData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const { filters, getFormattedData } = useDashboard();

  const fetchTaskSummary = () => {
    if (filters?.user_id) {
      setLoading(true);
      getTaskSummaryData(getFormattedData()).then((Response) => {
        if (Response.status === 200) {
          setTaskData(Response.data);
        } else {
          const msg = extractErrorMessage(Response) || TOAST_MESSAGES.FAILED_lOAD;
          toast.error(msg);
        }
      }).finally(() => setLoading(false));
    }
  };

  useEffect(() => {
    if (filters.user_id) {
      fetchTaskSummary();
    }
  }, [filters]);

  const data = taskData?.user ? [taskData] : [];
  const formattedData = data?.map(item => ({
    user: item.user,
    "Pending": item.PENDING,
    "In Progress": item.IN_PROGRESS,
    "Pending L1": item.PENDING_L1_APPROVAL,
    "Pending L2": item.PENDING_L2_APPROVAL,
  }));

  return (
    <Card className="bg-white shadow-xl rounded-xl border-red-100 p-4 overflow-x-auto min-w-full">
      <div>
        <Title className="text-lg">Task Summary</Title>
        <Text className="text-sm text-gray-500">User wise Task</Text>
      </div>

      {loading ? (
        <div className="h-72 flex items-center justify-center">
          <Common.Spinner />
        </div>
      ) : (
        <BarChart
          className="mt-6 h-72"
          data={formattedData}
          index="user"
          categories={["Pending", "In Progress", "Pending L1", "Pending L2"]}
          colors={["red-400", "green-300", "blue-400", "yellow-200"]}
          showXAxis={true}
          yAxisWidth={50}
          showAnimation={true}
          animationDuration={700}
          rotateLabelX={{ angle: 0, verticalShift: 10, xAxisHeight: 40 }}
          enableLegendSlider={true}
          valueFormatter={(v) => `${v.toLocaleString()}`}
        />
      )}
    </Card>
  );
};
export default TaskSummary;
